import * as React from 'react';
import { ICardTitleProps } from './types';
import { CARD_CLASS } from '../../../../constants';
import './CardTitle.scss';
import { markdown } from '../../../../../../../../helper/markdownHelper';
import ReactHtmlParser from 'react-html-parser';
import { Input } from 'kui';
import { onImgLoad } from '../../../helpers/onImgLoad';

export function CardTitle({
    editingName,
    isClone,
    isEditing,
    text,
    onHeightChange,
    onSave,
    onToggleLoadingImg,
    setEditing,
    setEditingName,
}: ICardTitleProps) {
    const className = CARD_CLASS + '__title';

    const [textMarked, setTextMarked] = React.useState(markdown(text));

    const inputRef = React.useRef(null);
    const textRef = React.useRef(null);

    const onSaveName = () => {
        if (isClone) return;

        if (editingName) {
            onSave(editingName);
        }
        setEditing(false);
    }

    const onKeyDown = (
        e: React.KeyboardEvent
    ) => {
        if (e.key === 'Escape' && !isClone) {
            setEditing(false);
        }
        if (e.key === 'Enter') {
            e.stopPropagation();
        }
    };

    React.useEffect(() => {
        setTextMarked(markdown(text));
        if (setEditingName) setEditingName(text);
    }, [text]);

    React.useEffect(() => {
        if (!onHeightChange || !textMarked || !textRef.current || isEditing) return;
        const cleanup = onImgLoad(textRef.current, onHeightChange, onToggleLoadingImg);
        return cleanup;
    }, [textMarked]);

    React.useEffect(() => {
        if (!isEditing) return;
        const input = inputRef.current && inputRef.current.getInput();
        if (input) {
            input.setSelectionRange(0, text.length);
        }
    }, [isEditing]);

    return isEditing ?
        <Input
            className={className + '-input'}
            ref={inputRef}
            value={editingName}
            onBlur={onSaveName}
            onEnter={onSaveName}
            onKeyDown={onKeyDown}
            onChange={e => {
                const { value } = e.target as HTMLInputElement;
                setEditingName(value);
            }}
            autoFocus={!isClone}
            disabled={!isEditing}
        />
        : <span ref={textRef} className={className}>
            {ReactHtmlParser(textMarked)}
        </span>;
}
